export default "__VITE_ASSET__6e066efe__"